import React, { createContext, useContext, useMemo } from "react"

export const TeacherAuthContext = createContext()

export const useTeacherAuthContext = () => {
  const context = useContext(TeacherAuthContext)
  if (context === undefined) {
    throw new Error(
      "useTeacherAuthContext must be used within a TeacherAuthProvider"
    )
  }
  return context
}

export const TeacherAuthProvider = ({ children }) => {
  // Add any teacher-specific states or hooks here in the future
  const values = useMemo(
    () => ({
      isConfigurationCompleted: true,
      // Placeholder for teacher-specific values/methods
    }),
    []
  )

  return (
    <TeacherAuthContext.Provider value={values}>
      {children}
    </TeacherAuthContext.Provider>
  )
}

export default TeacherAuthProvider
